export default __webpack_public_path__ + "static/media/motivations.62c429b1.wav";